export default {
  'SET_DEVICES'(state, data) {
    state.devices = data;
  },
  'SET_ROAMING_DEVICES'(state, data) {
    state.roamingDevices = data;
  },
  'ADD_DEVICE'(state, data) {
    state.devices.push(data);
  },
  'SET_NETWORK_TYPES'(state, data) {
    state.networkTypes = data;
  },
  'SET_DEVICE_TYPES'(state, data) {
    state.deviceTypes = data;
  },
  'SET_DEVICE_ENDPOINTS'(state, data) {
    state.deviceEndpoints = data;
  },
  'SET_MANUFACTURERS'(state, data) {
    state.manufacturers = data;
  },
  'MODIFY_DEVICE'(state, data) {
    if (state.devices) {
      state.devices = state.devices.map(item => {
        if (parseInt(item['id']) === parseInt(data['id'])) {
          return data;
        }

        return item;
      });
    }
  },
  'ADD_DEVICE_TOPIC'(state, data) {
    if (state.devices) {
      state.devices = state.devices.map(item => {
        if (parseInt(item['id']) === parseInt(data['deviceId'])) {
          if (!item['data']) {
            item['data'] = {
              id: data['deviceId'],
              name: '',
              states: {},
              topics: {}
            };
          }
          item['data']['topics'][data['topic']] = {
            filters: data['filters'],
            property: data['property'],
            topicId: data['topicId'],
            value: data['value']
          };
        }

        return item;
      });
    }
  },
  'DELETE_DEVICE_TOPIC'(state, data) {
    if (state.devices) {
      state.devices = state.devices.map(item => {
        if (parseInt(item['id']) === parseInt(data['id'])) {
          Object.keys(item['data']['topics']).forEach(topic => {
            const obj = item['data']['topics'][topic];
            if (parseInt(obj['topicId']) === parseInt(data['deviceTopicId'])) {
              delete item['data']['topics'][topic];
            }
          });
        }

        return item;
      });
    }
  },
  'SET_DEVICE_TOPICS'(state, data) {
    state.deviceTopics = data;
  }
};